// 📄 components/StepConfirmControl.tsx
import React from 'react';
import { AlertCircle } from 'lucide-react';
import { ConfirmationFormData } from '../../../../../services/commerce/integrationService';

interface StepConfirmControlProps {
  confirmationControlKey: string;
  ackSequence: string;
  deliverySequence: string;
  onChange: (field: keyof ConfirmationFormData, value: any) => void;
  isInvalid: boolean;
}

export function StepConfirmControl({ confirmationControlKey, ackSequence, deliverySequence, onChange, isInvalid }: StepConfirmControlProps) {
  return (
    <div className="space-y-4 animate-fadeIn">
      <div className="bg-blue-500/5 border border-blue-500/10 rounded-xl p-3 mb-2 space-y-1">
        <span className="text-[10px] font-bold text-blue-400 uppercase tracking-widest block">Ruta SPRO / Transacción SAP</span>
        <p className="font-mono text-xs text-gray-300">
          <span className="bg-zinc-800 px-1.5 py-0.5 rounded text-gray-400 font-bold mr-1.5">SPRO</span>
          <span>Materials Management → Purchasing → Confirmations → Set Up Confirmation Control</span>
        </p>
      </div>

      <div>
        <h3 className="text-lg font-medium text-blue-400">3. Set Up Confirmation Control (Control Key)</h3>
        <p className="text-sm text-gray-400">
          Crea o verifica la Control Key que define la secuencia de confirmaciones esperadas para la orden de compra (Acknowledgment e Inbound Delivery).
        </p>
      </div>

      <div className="bg-white/5 p-4 rounded-xl border border-white/5 grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <label className="block text-xs font-medium text-gray-400 mb-1">
            Control Key <span className="text-red-400">*</span>
          </label>
          <input
            type="text"
            value={confirmationControlKey}
            onChange={(e) => onChange('confirmationControlKey', e.target.value.toUpperCase())}
            placeholder="ej. Z004"
            maxLength={4}
            className={`w-full bg-zinc-800 border rounded-lg p-2.5 text-sm font-mono text-white focus:outline-none focus:border-blue-500 ${
              isInvalid && !confirmationControlKey ? 'border-red-500' : 'border-white/10'
            }`}
          />
        </div>

        <div>
          <label className="block text-xs font-medium text-gray-400 mb-1">Secuencia AB (Order Acknowledgment)</label>
          <input
            type="text"
            value={ackSequence}
            onChange={(e) => onChange('ackSequence', e.target.value)}
            placeholder="ej. AB Order Acknowledgment"
            className="w-full bg-zinc-800 border border-white/10 rounded-lg p-2.5 text-sm text-white focus:outline-none focus:border-blue-500"
          />
        </div>

        <div>
          <label className="block text-xs font-medium text-gray-400 mb-1">Secuencia LA (Inbound Delivery)</label>
          <input
            type="text"
            value={deliverySequence}
            onChange={(e) => onChange('deliverySequence', e.target.value)}
            placeholder="ej. LA Inbound Delivery"
            className="w-full bg-zinc-800 border border-white/10 rounded-lg p-2.5 text-sm text-white focus:outline-none focus:border-blue-500"
          />
        </div>
      </div>

      <div className="bg-blue-500/10 border border-blue-500/20 rounded-xl p-4 text-blue-400 flex gap-3 text-sm">
        <AlertCircle className="w-5 h-5 flex-shrink-0" />
        <div>
          <p className="font-semibold">Asignación al Tipo de Documento de Compra</p>
          <p className="text-xs text-blue-400/80 mt-0.5">
            No olvides asignar esta Control Key al tipo de documento de compra (Document Type) relevante en la misma vista SPRO para que aplique en las órdenes generadas.
          </p>
        </div>
      </div>
    </div>
  );
}
